import React from "react";
import PageSection from "../../Components/PageSection";
import MortMed from "../../images/mortimer-med.png";


export default class Mortimer extends React.Component {
  render() {
  return (
    <div>
       <PageSection 
          headerText="Mortimer: Behind the Walls" 
          divider="New Release - Behind the World Trilogy" 
          showOppositeSide={false}
          banner="Second Book of the Behind the World Trilogy" 
          sectionContent={[
            "Rachel Carter, a brilliant innovator on artificial intelligence, has been secretly imprisoned for over two years in a covert asylum. But when her creation, a revolutionary new AI named Mortimer, is released onto the internet from a state-of-the-art isolation lab, two unlikely heroes appear to free her. But are Father Homer and his friend Francisco meant to help save the world from Mortimer? Or from Rachel?",
            "Two old men stand quiet vigil over a closed cemetery, caretakers of the grass above and the dead below. Rumors of buried treasure bring a steady trickle of graverobbers, but the threat increases exponentially when a woman they call the White Witch begins to trouble their grounds. Ancient mysteries and current secrets collide as walls of stone and cyber are assailed, battered, and breached.",
            "Mortimer: Behind the Walls is the rousing second installment of the Behind the World series that chronicles the quests of Father Homer Bartholomew and his companion Francisco Stampa. The psychic powers Homer reluctantly explored in Black Jack: Behind the Waves become a critical component in answering a call that threatens the entire world and raises the question of what constitutes life."
          ]}
          sideLink="https://www.amazon.com/Mortimer-Behind-Walls-World/dp/1734209194"
          sidePicture={MortMed}
      />
    </div>
  )}
}